import {
	IGetApkInfo,
	ICreateApk,
	IEditApk,
	IGetPaginatedApk,
	IApk,
	IGetPaginatedApkForAssign,
	IApkForAssign,
	IGetRestaurantsByIDsCustomersForApk,
	IGetApkByIDsRestaurantsForApk,
	IAssignApk,
	IGetCustomersForAssignApk,
} from 'types';
import { AxiosResponse } from 'axios';
import { request } from '../index';

const serviceGetApkInfo = (apkID: string): Promise<IGetApkInfo> => {
	return request({ typeOfRequest: 'getWithToken', url: `/api/TabletApps/${apkID}` });
};

const serviceCreateApk = (data: ICreateApk): Promise<AxiosResponse<void>> => {
	return request({ typeOfRequest: 'postWithToken', url: `/api/TabletApps`, data });
};

const serviceUpdateApk = (data: IEditApk): Promise<AxiosResponse<void>> => {
	return request({ typeOfRequest: 'putWithToken', url: `/api/TabletApps/${data.id}`, data });
};

const serviceGetPaginatedApk = (args: IGetPaginatedApk): Promise<AxiosResponse<IApk>> => {
	return request({ typeOfRequest: 'postWithToken', url: `/api/TabletApps/filtered`, data: args });
};

const serviceDeleteApk = (apkID: string): Promise<AxiosResponse<void>> => {
	return request({ typeOfRequest: 'deleteWithTokenAndWithParameterInUrlLine', url: `/api/TabletApps/${apkID}` });
};

const serviceGetPaginatedApkForAssign = (args: IGetPaginatedApkForAssign): Promise<AxiosResponse<IApkForAssign>> => {
	return request({ typeOfRequest: 'postWithToken', url: `/api/RestaurantTabletApps/filtered`, data: args });
};

const serviceGetCustomersForAssignApk = (): Promise<IGetCustomersForAssignApk> => {
	return request({ typeOfRequest: 'getWithToken', url: '/api/CustomerTabletApps' });
};

const serviceGetRestaurantsByIDsCustomersForApk = (
	customerIDs: string[],
): Promise<IGetRestaurantsByIDsCustomersForApk> => {
	return request({ typeOfRequest: 'postWithToken', url: `/api/RestaurantTabletApps/restaurants`, data: customerIDs });
};

const serviceGetApkByIDsRestaurantsForApk = (restaurantIDs: string[]): Promise<IGetApkByIDsRestaurantsForApk> => {
	return request({
		typeOfRequest: 'postWithToken',
		url: `/api/RestaurantTabletApps/tabletapps`,
		data: restaurantIDs,
	});
};

const serviceAssignApk = (data: IAssignApk[]): Promise<AxiosResponse<void>> => {
	const dataForAssign = {
		assignments: data,
	};
	return request({ typeOfRequest: 'postWithToken', url: '/api/RestaurantTabletApps', data: dataForAssign });
};

export {
	serviceGetApkInfo,
	serviceCreateApk,
	serviceUpdateApk,
	serviceGetPaginatedApk,
	serviceDeleteApk,
	serviceGetPaginatedApkForAssign,
	serviceGetCustomersForAssignApk,
	serviceGetRestaurantsByIDsCustomersForApk,
	serviceGetApkByIDsRestaurantsForApk,
	serviceAssignApk,
};
